module.exports = __webpack_public_path__ + "static/media/Brain.f52f5cc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/about/Brain.jpg
// module id = 591
// module chunks = 8